var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"accesskey":_vm.accesskey,"id":_vm.id,"title":_vm.accesskeyTitle,"href":""},on:{"click":_vm.preventDefaultBehaviors}},[_vm._v("\n  :::\n")])}
var staticRenderFns = []

export { render, staticRenderFns }